import graphql from "babel-plugin-relay/macro";

const PartyPerformanceAnalysisQuery = graphql`
    query PartyPerformanceAnalysisQuery(
    $partyId: ID!
    $days: Int
    $weeks: Int
    $month: Int
    $all:Boolean
    ) {
        partyPerformanceAnalysis(partyId:$partyId,weeks:$weeks,days:$days,month:$month,all:$all)
        {
             edges{
                  node{
                    created
                    updatedPrice
                  }
             }
        }
    }
`;

export default PartyPerformanceAnalysisQuery;